<template>
  <v-card>
    <v-card-title>戻るボタンフォーム BackButtonForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="2">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              :rules="[varidation.required]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[0]"
              label="非表示"
              value="required"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules[1]"
              label="値を更新し戻る場合警告"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules[2]"
              label="ブラウザバック禁止"
              value="noWebBack"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules[3]"
              label="ブラウザ更新・削除時警告"
              value="warningLoad"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules[4]"
              label="別タブ表示の場合、閉じる"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules[5]"
              label="常時表示"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
      },
      rules: [],
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  mounted() {
    if (this.rule != "" || typeof this.rule == "undefined") {
      this.rules = this.rule.split(",");
    }
  },
  methods: {
    submit() {
      //前処理
      this.returnData.rule = this.rules.join(",");
      //
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
